export const ROLL_RESULT_GROUPS_LOAD = 'rollResult.ROLL_RESULT_GROUPS_LOAD';
export const ROLL_RESULT_GROUP_CREATE = 'rollResult.ROLL_RESULT_GROUP_CREATE';
export const ROLL_RESULT_GROUP_DESTROY = 'rollResult.ROLL_RESULT_GROUP_DESTROY';

export const ROLL_RESULT_COMPONENT_GROUPS_SET = 'rollResult.ROLL_RESULT_COMPONENT_GROUPS_SET';
export const ROLL_RESULT_COMPONENT_GROUPS_SET_COMMIT = 'rollResult.ROLL_RESULT_COMPONENT_GROUPS_SET_COMMIT';

export const ROLL_RESULT_GROUP_ADD = 'rollResult.ROLL_RESULT_GROUP_ADD';
export const ROLL_RESULT_GROUP_ADD_COMMIT = 'rollResult.ROLL_RESULT_GROUP_ADD_COMMIT';

export const ROLL_RESULT_GROUP_REMOVE = 'rollResult.ROLL_RESULT_GROUP_REMOVE';
export const ROLL_RESULT_GROUP_REMOVE_COMMIT = 'rollResult.ROLL_RESULT_GROUP_REMOVE_COMMIT';

export const ROLL_RESULT_GROUP_DICE_ROLLS_SET = 'rollResult.ROLL_RESULT_GROUP_DICE_ROLLS_SET';
export const ROLL_RESULT_GROUP_DICE_ROLLS_SET_COMMIT = 'rollResult.ROLL_RESULT_GROUP_DICE_ROLLS_SET_COMMIT';

export const ROLL_RESULT_GROUP_ORDER_SET = 'rollResult.ROLL_RESULT_GROUP_ORDER_SET';
export const ROLL_RESULT_GROUP_ORDER_SET_COMMIT = 'rollResult.ROLL_RESULT_GROUP_ORDER_SET_COMMIT';

export const ROLL_RESULT_GROUP_RESET = 'rollResult.ROLL_RESULT_GROUP_RESET';
export const ROLL_RESULT_GROUP_RESET_COMMIT = 'rollResult.ROLL_RESULT_GROUP_RESET_COMMIT';

export const ROLL_RESULT_DICE_ROLL_SET = 'rollResult.ROLL_RESULT_DICE_ROLL_SET';
export const ROLL_RESULT_DICE_ROLL_SET_COMMIT = 'rollResult.ROLL_RESULT_DICE_ROLL_SET_COMMIT';

export const ROLL_RESULT_DICE_ROLL_STATUS_SET = 'rollResult.ROLL_RESULT_DICE_ROLL_STATUS_SET';

export const ROLL_RESULT_COMPONENT_GROUP_PERSIST = 'rollResult.ROLL_RESULT_COMPONENT_GROUP_PERSIST';
export const ROLL_RESULT_COMPONENT_PERSIST = 'rollResult.ROLL_RESULT_COMPONENT_PERSIST';

export const ROLL_RESULT_COMPONENT_SIMULATED_GROUPS_SET = 'rollResult.ROLL_RESULT_COMPONENT_SIMULATED_GROUPS_SET';
export const ROLL_RESULT_COMPONENT_SIMULATED_GROUPS_REMOVE = 'rollResult.ROLL_RESULT_COMPONENT_SIMULATED_GROUPS_REMOVE';
export const ROLL_RESULT_COMPONENT_SIMULATED_GROUPS_PERSIST =
    'rollResult.ROLL_RESULT_COMPONENT_SIMULATED_GROUPS_PERSIST';
export const ROLL_RESULT_COMPONENT_SIMULATED_DICE_ROLL_SET = 'rollResult.ROLL_RESULT_COMPONENT_SIMULATED_DICE_ROLL_SET';
